// extracted by mini-css-extract-plugin
module.exports = {"comments":"_1WLk8SdydWnQcWSHVoPAZu","middle":"UNCNs76324ztAV4UbgDZG","info":"xK83GEhfB94PotIetYR5T"};